import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, inject, ViewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialog, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogModule, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatPaginatorModule } from '@angular/material/paginator';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ParticipantesType } from '../../../models/ParticipantesType';
import { TipoSolicitanteService } from '../../../services/tipo-solicitante.service';
import { TipoSolicitante } from '../../../models/TipoSolicitante';
import { Participante } from '../../../models/ParticipanteType';
import { ParticipanteService } from '../../../services/participante.service';
import { AutofocusDirective } from '../../../helpers/autofocus.directive';
import { CapitalizePipe } from '../../../pipes/capitalize.pipe';
import { UltimoUsoPipe } from '../../../pipes/ultimo-uso.pipe';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DlgBuzonIntegrantesComponent } from './dlg-buzon-integrantes.component';
import { DlgAddCiudadanoComponent } from '../../../commons/dlg-add-ciudadano/dlg-add-ciudadano.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ScnackbarData, ToastService, SnackbarStyles } from '../../../commons/toast.service';
import { Ciudadano } from '../../../models/ServidorPublico';
import { BuzonService } from '../../../services/buzon.service';
import { Buzon } from '../../../models/Buzon';

@Component({
  selector: 'app-dlg-destino',
  imports: [
    AutofocusDirective,
    MatDialogModule, MatDialogActions, MatDialogClose, MatDialogTitle, MatDialogContent,
    MatButtonModule, MatIconModule, MatTooltipModule,
    MatTableModule, MatButtonToggleModule, ReactiveFormsModule,
    FormsModule, MatFormFieldModule, MatInputModule, MatSelectModule,
    MatCardModule, CapitalizePipe, UltimoUsoPipe,
    MatPaginatorModule,
    MatTooltipModule
  ],
  templateUrl: './dlg-destino.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './dlg-destino.component.scss'
})
export class DlgDestinoComponent {
  displayedColumns: string[] = ['ciruc', 'nombres', 'opt', 'uso'];
  buzonesDisplayedColumns: string[] = ['departamento', 'cargo', 'opt'];
  @ViewChild('filter') filter?: ElementRef;

  dataSource = new MatTableDataSource<Participante>;
  buzonesDataSource = new MatTableDataSource<Buzon>;
  placeholder: string = "C\xE9dula, nombres, departamento";
  numCaracteres: number = 4;
  selectDes: string = "";
  selectedTipoSol = "1";
  idListaEnvio = null;
  participantes: ParticipantesType;
  tiposSolicitantes: TipoSolicitante[] = []
  listasEnvio: any[] = []
  tipoSolicitanteDefault = ""
  readonly dialogRef = inject(MatDialogRef<DlgDestinoComponent>);
  readonly data = inject<ParticipantesType>(MAT_DIALOG_DATA);

  noCitizens = false
  clearData = true

  snackbarData: ScnackbarData = {}

  filtro = ''

  constructor(
    private buzonService: BuzonService,
    private participanteServ: ParticipanteService,
    private tipoSolicitanteService: TipoSolicitanteService,
    private cdr: ChangeDetectorRef,
    private dlg: MatDialog,
    private toast: ToastService,
  ) {
    this.participantes = structuredClone(this.data);
    this.configureFilterPredicate(this.dataSource);
  }

  private normalizeText(value: any): string {
    return (value ?? '')
      .toString()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .trim();
  }

  private configureFilterPredicate(ds: MatTableDataSource<Participante>) {
    ds.filterPredicate = (item: Participante, filter: string): boolean => {
      const normalizedFilter = this.normalizeText(filter);
      if (!normalizedFilter) {
        return true;
      }

      const tokens = normalizedFilter.split(/\s+/).filter(Boolean);
      const searchable = this.normalizeText([
        item?.ciruc,
        item?.nombres,
        item?.departamento,
        item?.titulo,
        item?.cargo,
      ].join(' '));

      return tokens.every(token => searchable.includes(token));
    };
  }

  private resetDataSource(data: Participante[] = []) {
    this.dataSource = new MatTableDataSource<Participante>(data);
    this.configureFilterPredicate(this.dataSource);
  }

  ngOnInit(): void {
    this.loadDefaultTipoSolicitante();
    this.participanteServ.getListasEnvio().subscribe({
      next: (res: any[]) => {
        this.listasEnvio = res;
      }
    })
  }

  setFocus(): void {
    const ele = this.filter?.nativeElement;
    if (ele) {
      ele.focus();
      this.cdr.detectChanges();
    }
  }

  loadDefaultTipoSolicitante() {
    this.tipoSolicitanteService.list().subscribe({
      next: (response: TipoSolicitante[]) => {
        this.tiposSolicitantes = response;
        this.tiposSolicitantes.push({
          id: -1,
          descripcion: "Lista de env\u00edo"
        });
        const defaultType = this.tiposSolicitantes.find((tipo) => tipo.id.toString() === this.selectedTipoSol)
        if (defaultType) {
          this.tipoSolicitanteDefault = defaultType.id.toString()
          this.onChangeTipo(this.selectedTipoSol);
        }
        this.setFocus();
        this.cdr.detectChanges()
      }
    })
  }

  onChangeTipo(type: any) {
    this.filtro = '';
    this.placeholder = "C\xE9dula, nombres, departamento";
    this.numCaracteres = 4;
    if (type === "2") {
      this.numCaracteres = 10;
      this.placeholder = "B\xFAsqueda solo por c\xE9dula/ruc";
    }
    if (type !== "3") {
      this.resetDataSource();
    } else {
      this.numCaracteres = 3;
      this.placeholder = "B\xFAsqueda por buz\xF3n (departamento/cargo)";
      this.buzonesDataSource = new MatTableDataSource<Buzon>;
    }
    this.selectedTipoSol = type;
    this.setFocus();
    this.cdr.detectChanges();

  }

  onChangeListaEnvio(type: any) {
    this.idListaEnvio = type;
    this.resetDataSource();
    this.clearData = true;
    this.noCitizens = false;
    if (!type) {
      this.cdr.detectChanges();
      return;
    }
    // cargar participantes de la lista seleccionada
    this.participanteServ.getParticipanteListaEnvio(type).subscribe({
      next: (response: any[]) => {
          this.dataSource.data = response || [];
        if (this.dataSource.data.length <= 0) {
          this.clearData = false;
        }
        this.cdr.detectChanges();
      },
      error: () => {
        this.dataSource.data = [];
        this.clearData = false;
        this.cdr.detectChanges();
      }
    });
  }

  onKeyUp(e: Event) {
    const codeKey: any = e;
    codeKey.which !== 13
      ? e.preventDefault()
      : this.onFilter(codeKey.target.value);
  }

  filterChanged() {
    this.clearData = true;
    if ((this.filtro || '').trim().length === 0) {
      this.onFilter('');
    }
  }

  onFilter(data: any) {
    const filtroTexto = (data ?? '').toString().trim();

    if (filtroTexto.length === 0) {
      this.noCitizens = false;
      this.dataSource.filter = '';

      // Para "Lista de envío" recarga todos los destinatarios de la lista seleccionada.
      if (this.selectedTipoSol.toString() === "-1" && this.idListaEnvio) {
        this.participanteServ.getParticipanteListaEnvio(this.idListaEnvio).subscribe({
          next: (response: any[]) => {
              this.dataSource.data = response || [];
            this.clearData = this.dataSource.data.length > 0;
            this.cdr.detectChanges();
          },
          error: () => {
            this.dataSource.data = [];
            this.clearData = false;
            this.cdr.detectChanges();
          }
        });
      }
      return;
    }

    if (filtroTexto.length < this.numCaracteres) {
      return;
    }
    if (this.selectedTipoSol.toString() === "-1") {
      this.participanteServ.getParticipanteListaEnvio(this.idListaEnvio).subscribe({
        next: (response: any) => {
          this.dataSource.data = response;
          this.dataSource.filter = filtroTexto;
          if (this.dataSource.data.length <= 0) {
            this.clearData = false
          }
          this.cdr.detectChanges();
        }
      });
    }
    if (this.selectedTipoSol.toString() === "1") {
      this.participanteServ.getParticipanteServidorPublico(filtroTexto).subscribe({
        next: (response: Participante[]) => {
          response.sort(function (a, b) {
            if (a.nombres > b.nombres) { return 1; }
            if (a.nombres < b.nombres) { return -1; }
            return 0;
          });
          this.dataSource.data = response;
          if (this.dataSource.data.length <= 0) {
            this.clearData = false
          }
          this.cdr.detectChanges();
        }
      });
    }
    if (this.selectedTipoSol.toString() === "2") {
      this.participanteServ.getParticipanteCiudadano(filtroTexto).subscribe({
        next: (response: Participante[]) => {
          this.dataSource.data = response;
          if (this.dataSource.data.length <= 0) {
            this.noCitizens = true
            this.clearData = false
          } else {
            this.noCitizens = false
          }
          this.cdr.detectChanges();
        }
      });
    }
    if (this.selectedTipoSol.toString() === "3") {
      this.buzonService.buscarBuzon(data).subscribe({
        next: (response: Buzon[]) => {
          this.buzonesDataSource.data = response;
          if (this.buzonesDataSource.data.length <= 0) {
            this.clearData = false
          }
          this.cdr.detectChanges();
        }
      });
    }
  }

  onSelect(item: any, type: number) {
    let { fechaUso, ...res } = item;
    switch (type) {
      case 1:
        if (this.controlNoRepeatParticipant(res)) {
          return
        }
        this.participantes.destino?.push(res);
        break;
      case 2:
        if (this.controlNoRepeatParticipant(res)) {
          return
        }
        if (this.controlNoMixParticipantsDe(res)) {
          return
        }
        this.participantes.origen?.push(res);
        break;
      case 3:
        if (this.controlNoRepeatParticipant(res)) {
          return
        }
        this.participantes.copia?.push(res);
        break;
      default:
        break;
    }
  }

  onSelectBuzon(item: Buzon, type: number) {
    switch (type) {
      case 1:
        if (this.controlNoRepeatBuzonPara(item)) {
          return
        }
        this.participantes.destinoBuzon?.push(item);
        break;
      default:
        break;
    }
  }

  openIntegrantes(buzon: Buzon) {
    this.dlg.open(DlgBuzonIntegrantesComponent, {
      data: { buzon },
      width: '720px',
      panelClass: 'dlg-buzon-integrantes-panel'
    });
  }

  setPortavoz(type: number, item: Participante) {
    let participants: Participante[] = []
    switch (type) {
      case 1:
        this.participantes.destino.forEach(participant => {
          if (item.id === participant.id) {
            participant.portavoz = 1
          } else {
            participant.portavoz = 0
          }
          participants.push(participant)
        });
        this.participantes.destino = participants
        break
      case 2:
        this.participantes.origen.forEach(participant => {
          if (item.id === participant.id) {
            participant.portavoz = 1
          } else {
            participant.portavoz = 0
          }
          participants.push(participant)
        });
        this.participantes.origen = participants
        break
    }
  }

  controlNoRepeatParticipant(res: Participante): boolean {
    if (this.participantes.origen?.some(part => part.id === res.id as string)) {
      return true
    }
    if (this.participantes.destino?.some(part => part.id === res.id as string)) {
      return true
    }
    if (this.participantes.copia?.some(part => part.id === res.id as string)) {
      return true
    }
    return false
  }

  controlNoRepeatBuzonPara(res: Buzon): boolean {
    if (this.participantes.destinoBuzon?.some(part => part.id === res.id)) {
      return true
    }
    return false
  }

  controlNoMixParticipantsDe(res: Participante): boolean {
    if (this.participantes.origen.length <= 0) {
      return false
    }
    if (this.participantes.origen.some(part => part.idTipoSolicitante !== res.idTipoSolicitante)) {
      this.snackbarData.message = "Solo se pueden agregar remitentes de un tipo"
      this.snackbarData.style = SnackbarStyles.Warning
      this.snackbarData.iconName = "warning"
      this.toast.show(this.snackbarData)
      return true
    }
    return false
  }

  openDlgAddCitizen() {
    const dlgDestino = this.dlg.open(DlgAddCiudadanoComponent, {
      maxWidth: '40vw',
    });

    dlgDestino.afterClosed().subscribe((ciudadano: Participante) => {
      if (ciudadano) {
        this.dataSource.data = [ciudadano]
        this.cdr.detectChanges()
      }
    });
  }

  openDlgUpdateCitizen(data: Participante) {
    this.participanteServ.getCiudadano(data.ciruc).subscribe({
      next: (response: Ciudadano[]) => {
        const dlgDestino = this.dlg.open(DlgAddCiudadanoComponent, {
          maxWidth: '40vw',
          data: response.at(0)
        });

        dlgDestino.afterClosed().subscribe((ciudadano: Participante) => {
          if (ciudadano) {
            this.dataSource.data = [ciudadano]
            this.cdr.detectChanges()
          }
        });
      }
    });
  }


  onRemove(type: number, data: Participante) {
    if (type === 0) {
      this.participantes.origen = this.participantes.origen?.filter((part: Participante) => part.id !== data.id.toString());
    }
    if (type === 1) {
      this.participantes.destino = this.participantes.destino?.filter((part: Participante) => part.id !== data.id.toString());
    }
    if (type === 2) {
      this.participantes.copia = this.participantes.copia?.filter((part: Participante) => part.id !== data.id.toString());
    }
  }

  onRemoveBuzon(data: Buzon) {
    this.participantes.destinoBuzon = this.participantes.destinoBuzon?.filter((buzon: Buzon) => buzon.id !== data.id);
  }

}
